import React, { useState, useEffect } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import './AllModal.css';

function EditBookingModal({ booking, onSave, onClose }) {
  const [editedBooking, setEditedBooking] = useState({
    ...booking,
    startDate: new Date(booking.startDate),
    endDate: new Date(booking.endDate)
  });

  const handleSave = () => {
    onSave({
      ...editedBooking,
      startDate: editedBooking.startDate.toISOString(),
      endDate: editedBooking.endDate.toISOString()
    });
  };

  // Handle ESC key press
  useEffect(() => {
    const handleEscKey = (event) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };

    document.addEventListener('keydown', handleEscKey);
    return () => {
      document.removeEventListener('keydown', handleEscKey);
    };
  }, [onClose]);

  // Handle click outside modal
  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className="edit-booking-modal-overlay" onClick={handleOverlayClick}>
      <div className="edit-booking-modal-content">
        <h2>Edit Booking</h2>
        <div className="edit-booking-modal-form">
          <div className="edit-booking-modal-field">
            <label>Type</label>
            <select
              value={editedBooking.type}
              onChange={e => setEditedBooking({ ...editedBooking, type: e.target.value })}
            >
              <option value="Hotels">Hotels</option>
              <option value="Cruises">Cruises</option>
              <option value="Flights">Flights</option>
              <option value="DMCs">DMCs</option>
              <option value="Homes/Villas">Homes/Villas</option>
              <option value="Insurance">Insurance</option>
              <option value="Packages">Packages</option>
              <option value="Transportation">Transportation</option>
              <option value="Multiday Tours">Multiday Tours</option>
              <option value="Day Tours & Activities">Day Tours & Activities</option>
            </select>
          </div>
          <div className="edit-booking-modal-field">
            <label>Name on Reservation</label>
            <input
              value={editedBooking.nameOnReservation}
              onChange={e => setEditedBooking({ ...editedBooking, nameOnReservation: e.target.value })}
            />
          </div>
          <div className="edit-booking-modal-field">
            <label>Reservation Number</label>
            <input
              value={editedBooking.reservationNumber}
              onChange={e => setEditedBooking({ ...editedBooking, reservationNumber: e.target.value })}
            />
          </div>
          <div className="edit-booking-modal-field">
            <label>Start Date & Time</label>
            <DatePicker
              selected={editedBooking.startDate}
              onChange={date => setEditedBooking({ ...editedBooking, startDate: date })}
              showTimeSelect
              timeFormat="HH:mm"
              timeIntervals={15}
              dateFormat="MMMM d, yyyy h:mm aa"
              showMonthDropdown
              showYearDropdown
              dropdownMode="select"
            />
          </div>
          <div className="edit-booking-modal-field">
            <label>End Date & Time</label>
            <DatePicker
              selected={editedBooking.endDate}
              onChange={date => setEditedBooking({ ...editedBooking, endDate: date })}
              showTimeSelect
              timeFormat="HH:mm"
              timeIntervals={15}
              dateFormat="MMMM d, yyyy h:mm aa"
              showMonthDropdown
              showYearDropdown
              dropdownMode="select"
            />
          </div>
          <div className="edit-booking-modal-field">
            <label>Details</label>
            <textarea
              value={JSON.stringify(editedBooking.details, null, 2)}
              onChange={e => setEditedBooking({ ...editedBooking, details: JSON.parse(e.target.value || '{}') })}
            />
          </div>
        </div>
        <div className="edit-booking-modal-actions">
          <button onClick={onClose}>Cancel</button>
          <button onClick={handleSave}>Save</button>
        </div>
      </div>
    </div>
  );
}

export default EditBookingModal;